import { render, staticRenderFns } from "./ModalRestringirTipoPre.vue?vue&type=template&id=3f96704e&scoped=true"
import script from "./ModalRestringirTipoPre.vue?vue&type=script&lang=js"
export * from "./ModalRestringirTipoPre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96704e",
  null
  
)

export default component.exports